export const getValueWithFinancingFormat = value =>
  // format number to locale DE, because it separates thousands of 4 digits with dot
  Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(value)
